module.exports = __webpack_public_path__ + "img/exam (2).2303fb09.jpeg";